const {
  SHORT_URLS_SETTINGS_SUCCESS,
  SHORT_URLS_SETTINGS_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SHORT_URLS_SETTINGS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SHORT_URLS_SETTINGS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
